<template>
  <div class="tableWithPerPageSelection"
  v-if="briefStocke.fromDate && briefStocke.toDate">
    <div class="entete pdb-20px border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeProduitUnitaire.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a @click="annuler()"
               class="button">
              {{ $t('listeProduitUnitaire.actions.back')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="pdt-20px">
      <div>
        <div class="columns level">
          <div class="has-text-default columns is-marginless
            is-multiline is-vcentered mgt-10px">
            <p
              v-if="briefStocke.produitLocation && briefStocke.produitLocation.libelle"
              class="column is-narrow is-paddingless mgr-20px">
              {{$t('listeProduitUnitaire.location', { location: briefStocke.produitLocation.libelle
                + (briefStocke.produitLocation.reference ?
                  ' - ' + briefStocke.produitLocation.reference : '')}
              )}}
            </p>
            <span v-if="briefStocke.fromDate && briefStocke.toDate"
              class="is-paddingless">
              {{$t('listeProduitUnitaire.periode',
              { dateDebut: dateDebut,
              dateFin: dateFin} )}}
            </span>
          </div>
          <div class="column">
            <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
              <b-input :placeholder="$t('remiseBancaire.recherche')" type="search" icon="magnify"
                       v-model="briefStocke.autoFromCommande">
              </b-input>
            </form>
          </div>
          <div class="column is-narrow level-right">
            <div class="column is-pulled-right is-paddingless">
              <parametrage-table class="mgl-10px"
                :reference-table="referenceTable"
                @endLoadParamtre="startArrayRendering = true">
              </parametrage-table>
            </div>
            <div class="column is-pulled-right is-paddingless">
              <button class="button" @click='showPanier = !showPanier'>
                <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7" v-if="panier && returnValeurPanier === 0">
                {{$t('listeProduitUnitaire.panier')}}
                </span>
                <span class="is-size-7" v-else>{{returnValeurPanier | formatDevise}}</span>
              </button>
              <div class="info-circle-right background-danger is-pulled-right"
                   v-if="panier.length > 0">
                <span class="inside-circle">{{ panier.length > 9 ? '9+' : panier.length }}</span>
              </div>
            </div>
            <div class="column is-pulled-right is-paddingless">
              <button class="button" @click='showBrief = !showBrief'>
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">{{$t('listeProduitUnitaire.brief')}}</span>
              </button>
              <div class="info-circle-right background-primary is-pulled-right"
                   :class="{'is-invisible': nombreFiltre === 0}">
                <span class="inside-circle">{{nombreFiltre}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-server-table class="mgt-10px" v-if="startArrayRendering"
                      url=""
                      :columns="columns"
                      :options="options"
                      @loaded="finLoading"
                      @loading="debutLoading"
                      @error="finLoading"
                      :ref="referenceTable">
        <template slot='afterTable'>
          <table-items-in-view :perPage="resultPerPage"
            @input="$refs[referenceTable].setLimit($event)"/>
        </template>
        <div slot="addPanier" slot-scope="props" class="has-text-centered">
          <button
            class="ripple button" :class="getColorAddPanier(props.row.id)"
            @click="ajouterAuDevisCommande(props.row)">
            <b-icon icon="cart"></b-icon>
          </button>
        </div>
        <div slot="decoration.resteAVendreMax" slot-scope="props" class="has-text-centered">
          <div v-if="props.row.decoration"
            class="notClickable button is-fullwidth" :class="props.row.decoration.dispoClass">
            {{ props.row.decoration.resteAVendreMax.toFixed(0) + '%' }}
          </div>
        </div>
        <div slot="affectation" slot-scope="props">
          <a class="lien" @click="affichageAffectations(props.row)"
            v-if="props.row.affectations && props.row.affectations.length > 0">
            {{props.row.affectations[0].libelle}}
            <span v-if="props.row.affectations.length > 1">...</span>
          </a>
        </div>
        <div slot="disposition" slot-scope="props">
          <div>
            {{ props.row.produitFace.disposition }}
          </div>
        </div>
        <div slot="societe" slot-scope="props">
          <div>{{ getLibelleSociete(props.row.supportCommercial.societeId) }}</div>
        </div>
      </v-server-table>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showBrief || showPanier">
        <brief v-if="showBrief"
               :produitsLocation="produitsLocation"
          @toggleBrief="showBrief = !showBrief"
          @appliquerBrief="recherche()"/>
        <app-panier
          :canMakeReseauPerso="canMakeReseauPerso"
          @togglePanier="showPanier = !showPanier"
          @ajouterLigneToCommande="$router.go(-1)"
          v-if="showPanier"/>
      </div>
    </transition>
    <b-modal v-model="showPopupAffectation"
        has-modal-card
        class="modal" width="746px">
      <popup-affectations :produit="produitPourAffectation" />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import AppBreadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, SORT_ICON, NO_PAGINATION, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE_PLANNING,
} from '@/configuration/clientTableConf';
import inProgress from '@/services/general/inProgress';
import * as types from '@/store/modules/commande-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { COMMANDES, FACTURES, DEVIS } from '@/configuration/permissionsBodacConf';
import formatDate from '@/services/general/formatDate';
import * as typesProduitFace from '@/store/modules/produitFace-mutation-type';
import AppPanier from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/panier/panierAjoutProduitFace';
import {
  ANNEE,
  ETAT_COMMANDE_PARTIELLEMENT,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  TYPE_COMMANDE,
} from '@/configuration/devisConf';
import popupAffectations from '@/components/devisCommandes/rechercheCatalogue/popupAffectations';
import { getAll } from '@/api/produit/produitLocation';
import calculDateFin from '@/services/general/calculDateFin';
import TableItemsInView from '@/components/general/TableItemsInView';
import { CATEGORIE_LOCATION, CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';
import getLignesCommandesWithType from '@/services/devisCommandes/ligneCommande/getLignesCommandesWithType';
import { ROUTE_ALLOWED_WITHOUT_CLEAN_STORE_FOR_LOGISTIQUE } from '@/configuration/planning/planningConf';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT, REGIE } from '@/configuration/societe/societe';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import getProduitLocDefaut from '@/services/dcf/produit/getProduitLocDefaut';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_PLANNING_AJOUT_FACE } from '@/configuration/general/referenceTableConf';
import brief from './briefProduitUnitaire';

const ProduitFace = createNamespacedHelpers('produitFace');
const Commande = createNamespacedHelpers('commande');
const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  name: 'rechercheProduit',
  components: {
    appBreadcrumb: AppBreadcrumb,
    brief,
    AppPanier,
    popupAffectations,
    TableItemsInView,
    parametrageTable,
  },
  beforeRouteLeave(to, from, next) {
    if (!ROUTE_ALLOWED_WITHOUT_CLEAN_STORE_FOR_LOGISTIQUE.includes(to.name)) {
      this.removeCommande();
      this.clearPanier();
      this.clearBrief();
    }
    next();
  },
  data() {
    return {
      perms: FACTURES,
      messages: [],
      startArrayRendering: false,
      produitsLocation: [],
      error: false,
      showBrief: false,
      showPanier: false,
      showPopupAffectation: false,
      produitPourAffectation: null,
      resultPerPage: RESULTS_PER_PAGE_PLANNING,
      referenceTable: REFERENCE_PLANNING_AJOUT_FACE,
    };
  },
  computed: {
    ...ProduitFace.mapGetters({
      produits: 'produits',
      totalProduits: 'totalProduits',
      briefStocke: 'brief',
      panier: 'panier',
    }),
    ...Parametres.mapGetters({
      tarifsUnitaire: 'tarifsUnitaire',
      parametresInterne: 'parametresInterne',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Commande.mapGetters({
      commandeCourante: 'commande',
    }),
    ...societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActive: 'societeActive',
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    canMakeReseauPerso() {
      return !(this.commandeCourante.role !== REGIE
        || this.commandeCourante.etat === ETAT_COMMANDE_PARTIELLEMENT
        || (this.commandeCourante.type === TYPE_COMMANDE
          && (this.commandeCourante.etat === ETAT_FACTURE
            || this.commandeCourante.etat === ETAT_FACTURE_PARTIELLEMENT)));
    },
    dateDebut() {
      return formatDate(this.briefStocke.fromDate);
    },
    returnValeurPanier() {
      let prix = 0;
      this.panier.forEach((ligne) => {
        ligne.lignesCommande.forEach((ligneCommande) => {
          prix += ligneCommande.totalHt && ligneCommande.typeProduit === CATEGORIE_LOCATION
            ? ligneCommande.totalHt : 0;
        });
      });
      return prix;
    },
    dateFin() {
      return formatDate(this.briefStocke.toDate);
    },
    breadcrumb() {
      const current = {
        title: this.$i18n.t('listeProduitUnitaire.title'),
        route: { name: 'rechercheProduitUnitaire' },
        isActive: true,
      };
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'breadcrumb')) {
        const output = Array.from(this.$route.params.breadcrumb);
        output[output.length - 1].isActive = false;
        output.push(current);
        return output;
      }
      return [
        current,
      ];
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    columns() {
      const columns = ['addPanier', 'decoration.resteAVendreMax', 'reference', 'produitFace.format', 'produitFace.materielType', 'disposition', 'produitFace.adresse.adresse1', 'produitFace.adresse.codePostal', 'produitFace.adresse.ville', 'affectation'];
      if (this.societesInformations.length > 1 && !this.filtrerProduitParSociete
        && !this.filtrerProduitParAgence) {
        columns.push('societe');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          addPanier: '',
          'decoration.resteAVendreMax': '',
          reference: this.$i18n.t('listeProduitUnitaire.table.reference'),
          'produitFace.format': this.$i18n.t('listeProduitUnitaire.table.format'),
          'produitFace.materielType': this.$i18n.t('listeProduitUnitaire.table.materiel'),
          'produitFace.adresse.adresse1': this.$i18n.t('listeProduitUnitaire.table.address'),
          'produitFace.adresse.codePostal': this.$i18n.t('listeProduitUnitaire.table.zipCode'),
          'produitFace.adresse.ville': this.$i18n.t('listeProduitUnitaire.table.city'),
          affectation: this.$i18n.t('listeProduitUnitaire.table.affectation'),
          societe: this.$i18n.t('listeProduitUnitaire.table.societe'),
          disposition: this.$i18n.t('listeProduitUnitaire.table.disposition'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: [
          'reference',
          'produitFace.format',
          'produitFace.materielType',
          'produitFace.adresse.adresse1',
          'produitFace.adresse.codePostal',
          'produitFace.adresse.ville',
        ],
        columnsClasses: {
          addPanier: 'colonneSelected-35 is-paddingless',
          'decoration.resteAVendreMax': 'colonneSelected is-paddingless',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.briefStocke.agencesId.length === 0) {
            this.briefStocke.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) {
            data.query = this.briefStocke;
          }
          data.query.proposableLc = true;
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.actionsLoadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
    nombreFiltre() {
      let nombreFiltre = 0;
      if (this.briefStocke) {
        Object.keys(this.briefStocke).forEach((nomParamBrief) => {
          if (nomParamBrief === 'toDate'
          || nomParamBrief === 'actif'
          || nomParamBrief === 'autoFromCommande'
          || nomParamBrief === 'eclaire'
          || nomParamBrief === 'budgetMax') return;
          if ((Array.isArray(this.briefStocke[nomParamBrief])
            && this.briefStocke[nomParamBrief].length > 0)
            || (!Array.isArray(this.briefStocke[nomParamBrief])
            && this.briefStocke[nomParamBrief] != null)) {
            nombreFiltre += 1;
          }
        });
      }
      if (nombreFiltre <= 9) {
        return nombreFiltre;
      }
      return '9+';
    },
  },
  methods: {
    ...Commande.mapMutations({
      removeCommande: types.REMOVE_COMMANDE,
      setCommande: types.SET_COMMANDE,
    }),
    ...ProduitFace.mapMutations({
      clearPanier: typesProduitFace.CLEAR_PANIER,
      clearBrief: typesProduitFace.CLEAR_BRIEF,
      setPanier: typesProduitFace.SET_PANIER,
    }),
    ...ProduitFace.mapActions({
      actionsLoadProduits: 'loadProduits',
      actionsAddLigneInPanier: 'addLigneInPanier',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    annuler() {
      this.clearPanier();
      this.clearBrief();
      const lignesUnitaire = getLignesCommandesWithType(
        this.commandeCourante.lignesCommande, CATEGORIE_UNITAIRE,
      );
      this.setPanier(lignesUnitaire);
      this.$router.go(-1);
    },
    findGoodPerm() {
      if (!this.$route.params.breadcrumb) return;
      if (this.$route.params.breadcrumb[1].route.name.includes('devis')) this.perms = DEVIS;
      if (this.$route.params.breadcrumb[1].route.name.includes('commande')) this.perms = COMMANDES;
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getColorAddPanier(idProduit) {
      if (!this.panier) return 'is-primary';
      const isAlreadyAdd = this.panier.some((ligne) => {
        return idProduit === ligne.produitId;
      });
      if (isAlreadyAdd) return 'is-success';
      return 'is-primary';
    },
    checkErreur(informationProduit) {
      this.error = false;
      this.messages = [];
      if (!this.briefStocke.produitLocation) {
        this.messages.push(this.$i18n.t('listeProduitUnitaire.errors.produitLoc'));
      }
      if (this.briefStocke.produitLocation
        && this.briefStocke.produitLocation.id === PRODUIT_ID_LOCATION_PAR_DEFAUT
        && !informationProduit.produitFace.produitParDefautId) {
        this.messages.push(this.$i18n.t('listeProduitUnitaire.errors.produitDefaultLoc'));
      }
      if (this.messages.length > 0) this.error = true;
    },
    async ajouterAuDevisCommande(face) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.checkErreur(face);
        if (this.error) {
          loadingComponent.close();
          messageErreur(this.$i18n, this.messages.join('\n'));
          return;
        }
        let produitLocation = this.briefStocke.produitLocation;
        if (produitLocation && produitLocation.id === PRODUIT_ID_LOCATION_PAR_DEFAUT) {
          produitLocation = await getProduitLocDefaut(
            this.produitsLocation,
            face.supportCommercial.societeId,
            face.produitFace.produitParDefautId,
            this.societeActiveId,
          );
          if (!produitLocation) {
            messageErreur(this.$i18n, this.$i18n.t('listeProduitUnitaire.errors.errorProduitLocationNotFound'));
            loadingComponent.close();
            return;
          }
        }
        await this.actionsAddLigneInPanier(
          {
            produitFaceId: face.id,
            produitLocation: produitLocation,
            dateDebut: this.briefStocke.fromDate,
            dateFin: this.briefStocke.toDate,
          },
        );
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    affichageAffectations(produit) {
      this.produitPourAffectation = produit;
      this.showPopupAffectation = true;
    },
  },
  async mounted() {
    if (!this.$route.params.breadcrumb) {
      this.removeCommande();
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.$router.go(-1);
    }
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      await this.loadSocietes({});
      const queryItem = {
        query: {
          numerique: false,
          societeId: this.societeActiveId,
        },
        orderBy: 'ProduitLocation.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.produitsLocation = (await getAll(queryItem)).data.result.items;
      this.produitsLocation.push({ id: PRODUIT_ID_LOCATION_PAR_DEFAUT, libelle: this.$t('listeProduitUnitaire.briefContent.locationDefault') });
      if (this.societeActive.produitIdDefautUnitaire) {
        this.briefStocke.produitLocation = this.produitsLocation.find((loc) => {
          return loc.id === this.societeActive.produitIdDefautUnitaire;
        });
      }
      this.briefStocke.fromDate = this.commandeCourante.datePremierAffichage || moment().toDate();
      if (this.briefStocke.produitLocation
        && this.briefStocke.produitLocation.id !== PRODUIT_ID_LOCATION_PAR_DEFAUT) {
        this.briefStocke.toDate = await calculDateFin(
          this.briefStocke.fromDate,
          this.briefStocke.produitLocation.produitLocation.quantite,
          this.briefStocke.produitLocation.produitLocation.uniteVente,
        );
        if (!this.briefStocke.toDate) {
          this.briefStocke.toDate = await calculDateFin(this.briefStocke.fromDate, 1, ANNEE);
        }
      } else {
        this.briefStocke.toDate = await calculDateFin(this.briefStocke.fromDate, 1, ANNEE);
      }
      if (this.filtrerProduitParAgence) {
        this.briefStocke.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      if (this.moduleSecteurActive) {
        this.briefStocke.secteurIds = this.user.secteursId ?? [];
      }
      if (this.commandeCourante) {
        const lignesUnitaire = getLignesCommandesWithType(
          this.commandeCourante.lignesCommande, CATEGORIE_UNITAIRE,
        );
        lignesUnitaire.forEach((ligne) => {
          ligne.isAlreadySelect = true;
        });
        await this.setPanier(lignesUnitaire);
      }
      this.findGoodPerm();
      loadingComponent.close();
      if (!this.briefStocke.produitLocation) { this.showBrief = true; }
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
    this.setInformationPage(this.$t('pageGescom.planning.face'));
  },
};
</script>
